import React from 'react';
import { twMerge } from 'tailwind-merge';
import Select, { components } from 'react-select';
import Checkbox from '../Checkbox';
import { IOption } from 'src/config/types';
import FieldErrorMessage from '../TextInput/FieldErrorMessage';
import './index.css';

interface IMultiSelect {
  disabled?: boolean;
  options: IOption[];
  value: IOption[] | any;
  error: string | undefined;
  handleChange: (option: any, action: any) => void;
  controlShouldRenderValue?: boolean;
  style?: any;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  name?: string;
  isMulti?: boolean;
  placeholder?: string;
  label?: string;
  required?: boolean;
  view?: boolean;
  className?: string;
}

const Option = (props: any) => {
  return (
    <div>
      <components.Option {...props}>
        {props.isMulti ? (
          <Checkbox
            checked={props.isSelected}
            onChange={() => null}
            label={props.label}
            htmlFor={props.label}
            labelClassName="capitalize text-sm  pt-1"
          />
        ) : (
          <>{props.label}</>
        )}
      </components.Option>
    </div>
  );
};

export default function MultiSelect({
  disabled,
  value,
  options,
  handleChange,
  error,
  controlShouldRenderValue = true,
  style,
  onBlur,
  name,
  isMulti = true,
  placeholder,
  label,
  required,
  view,
  className,
}: IMultiSelect) {
  return (
    <div className="flex flex-col">
      {label ? (
        <label
          htmlFor="select-search"
          className={`font-base font-SFProDisplay pointer-events-none mb-2 font-700 text-[14px] capitalize ${
            disabled ? 'text-gray-300' : 'text-black'
          } `}
        >
          {label}
          {required && <span className="pl-1 text-red-600">*</span>}
        </label>
      ) : null}
      <Select
        onChange={handleChange}
        value={value}
        className={twMerge(
          'basic-single font-SFProDisplay placeholder:font-normal  placeholder:text-sm placeholder:text-slate-500',
          className ?? className
        )}
        classNamePrefix="react-select"
        defaultValue={options[0]}
        closeMenuOnSelect={true}
        onBlur={onBlur}
        placeholder={placeholder ? placeholder : 'Select'}
        styles={{
          indicatorsContainer: (baseStyles, state) => ({
            display: view ? 'none' : 'inline-flex',
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            ...style,
            backgroundColor: '#FFFFFF',
            border: '1px solid #DCDFE4',
            minHeight: '32px',
            borderRadius: '9999px',
            pointerEvents: view || disabled ? 'none' : 'auto',
            color: '#0B1B4E',
            fontSize: '14px',
            paddingLeft: '4px',
            paddingRight: '4px',
            cursor: 'pointer',
            boxShadow: state.isFocused ? '0 0 0 1px #DCDFE4' : 0,
            '&:hover': {
              border: '1px solid #0b1b4e',
            },
            fontFamily: 'SF-Pro-Display-Regular',
          }),
          valueContainer: (baseStyles, state) => ({
            ...baseStyles,
            paddingTop: '5px',
            paddingBottom: '5px',
            textTransform: 'capitalize',
          }),
          menuList: (base, props) => ({
            ...base,
            alignItems: 'flex-start',
          }),
          menu: (base) => ({
            ...base,
            width: 'max-content',
            minWidth: '100%',
          }),
        }}
        controlShouldRenderValue={controlShouldRenderValue}
        components={{
          Option,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        isMulti={isMulti}
        hideSelectedOptions={false}
        isDisabled={disabled}
        name={name}
        options={options}
      />
      {error ? <FieldErrorMessage message={error} className="mt-2" /> : null}
    </div>
  );
}
